import { render, staticRenderFns } from "./SpcmViewV1.vue?vue&type=template&id=a58b2672&scoped=true"
import script from "./SpcmViewV1.vue?vue&type=script&lang=js"
export * from "./SpcmViewV1.vue?vue&type=script&lang=js"
import style0 from "./SpcmViewV1.vue?vue&type=style&index=0&id=a58b2672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58b2672",
  null
  
)

export default component.exports